import React from 'react';
import './Users.css';

const Users: React.FC = () => {
  return (
    <div className="users-page">
      <div className="page-header">
        <h1>Users</h1>
        <p className="page-description">Manage user accounts and permissions</p>
      </div>
      <div className="page-content">
        <div className="empty-state">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <h2>Coming Soon</h2>
          <p>User management features will be available here.</p>
        </div>
      </div>
    </div>
  );
};

export default Users;

